import { render } from "./NfseConfig.vue?vue&type=template&id=bd9aa5e4"
import script from "./NfseConfig.vue?vue&type=script&lang=js"
export * from "./NfseConfig.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__